import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import styles from "./Search.module.css";

export default function FreeSolo({ data, fn }) {
  const products = [
    ...new Set(
      data
        .filter((d) => d["PRODUCT NAME"].length)
        .map((d) => d["PRODUCT NAME"] + " | product")
    ),
  ];
  const growers = [
    ...new Set(
      data
        .filter((d) => d["LIC NAME"].length)
        .map((d) => d["LIC NAME"] + " | lic")
    ),
  ];
  const strains = [
    ...new Set(
      data
        .filter((d) => d["STRAIN"].length)
        .map((d) => d["STRAIN"] + " | strain")
    ),
  ];
  const searchOptions = [...products, ...growers, ...strains];
  return (
    <div className={styles.Search} style={{ width: "100%", maxWidth: 600 }}>
      <Autocomplete
        id="free-solo-demo"
        options={searchOptions.sort()}
        onChange={(event, newValue) => fn(newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Search by product, strain, or company"
            margin="normal"
            variant="outlined"
          />
        )}
      />
    </div>
  );
}
